import { useContext } from 'react';

import { SettingsContext } from './context';
import { AppProps } from './types';

export const useAppSettings = (): AppProps => {
  const { appSettings, setAppSettings } = useContext(SettingsContext);

  const showTabs = () => setAppSettings({ ...appSettings, isTabsShown: true });

  const hideTabs = () => setAppSettings({ ...appSettings, isTabsShown: false });

  return { isTabsShown: appSettings.isTabsShown, user: appSettings.user, showTabs, hideTabs };
};
